module.exports = __webpack_public_path__ + "static/a-family-of-titan-scholars-legacy-menu-thumbnails-400x400-3e67602bc1013e26c21c88ade2f88a36.jpg";